import React, { Fragment } from "react";

export const NotificationMobile = () => {
  return <Fragment></Fragment>;
};
